export const INVOICE_CURRENCY = 'GBP';
export const INVOICE_VAT_RATE = 0.2;

export const CREDIT_NOTE_PREFIX = 'CN-';
